"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scale = exports.formatAsPrice = exports.formatAsPriceAndTruncate = void 0;
const isInteger = (value) => typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
const formatAsPriceAndTruncate = (price) => {
    if (isInteger(price)) {
        return `$${price}`;
    }
    return (0, exports.formatAsPrice)(price);
};
exports.formatAsPriceAndTruncate = formatAsPriceAndTruncate;
const formatAsPrice = (price) => {
    const fixed = price.toFixed(2);
    const twoDecimals = fixed.replace(/(\d)(?=(\d{3})+\.)/g, '$1,');
    return `$${twoDecimals}`;
};
exports.formatAsPrice = formatAsPrice;
const scale = (price) => Math.round(price * 100) / 100;
exports.scale = scale;
//# sourceMappingURL=money.js.map